// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2UQF0","form":"styles_form__LMqbC"};